<template>
  <section class="plan" name="plan">
    <div class="container">
      <a-typography-title :level="1">
        专利技术能力
      </a-typography-title>
      <div class="box_swiper">
        <Swiper slidesPerView="auto" :speed="600"
                :navigation="{prevEl:'.button_prev',nextEl:'.button_next',disabledClass:'button_disabled'}">
          <SwiperSlide v-for="(item,index) in tab.list">
            <a :class="{active:(index+1)===tab.active}"
               @click="tab.active=index+1">
              {{ item.title }}
            </a>
          </SwiperSlide>
        </Swiper>
        <a-button type="link" class="button_prev">
          <template #icon>
            <LeftOutlined />
          </template>
        </a-button>
        <a-button type="link" class="button_next">
          <template #icon>
            <RightOutlined />
          </template>
        </a-button>
      </div>
      <a-tabs ref="tab" v-model:activeKey="tab.active" centered>
        <a-tab-pane v-for="(item,index) in tab.list"
                    :key="index+1" :tab="item.title">
          <div class="item" :class="`i_${index+1} ${tab.show===index+1?'tab_show':''}`">
            <a-row>
              <a-col class="box_content"
                     :xs="24" :md="16">
                <a-typography>
                  <a-typography-title :level="5">
                    {{ item.title }}
                  </a-typography-title>
                  <a-typography-paragraph>
                    <ul>
                      <li v-for="(v,i) in item.text" :key="i">
                        {{ v }}
                      </li>
                    </ul>
                  </a-typography-paragraph>
                  <!--<a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">-->
                  <!--  <a-button type="link" class="button_n_3" target="_blank"-->
                  <!--            @click="item.click">-->
                  <!--    了解更多-->
                  <!--  </a-button>-->
                  <!--</a-space>-->
                </a-typography>
              </a-col>
              <a-col class="box_image"
                     :xs="0" :md="8">
                <div class="image" />
              </a-col>
            </a-row>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import {
  LeftOutlined,
  RightOutlined
} from '@ant-design/icons-vue';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { DataInterface } from '@interface/public';

export default {
  name: 'home_plan',
  components: {
    LeftOutlined,
    RightOutlined,
    Swiper,
    SwiperSlide
  },
  data(): DataInterface {
    return {
      tab: {
        active: 1,
        show: 1,
        list: [
          {
            title: '精准度量',
            text: [
              '业务决策指标提取',
              '实时精准度量',
              '提高计算机资源调整的便捷性',
              '节约计算资源的使用成本'
            ],
            click: () => {
            }
          },
          {
            title: '算力共享池',
            text: [
              '在离线混部',
              '实现对服务集群的动态调度',
              '提升服务集群的资源利用率'
            ],
            click: () => {
            }
          },
          {
            title: '快速规格压测',
            text: [
              '快速查找到性能匹配最优的目标服务器',
              '提升软件的运行效率',
              '节约服务器成本'
            ],
            click: () => {
            }
          },
          {
            title: '快速流量压测',
            text: [
              '使用线上实时服务的流量对服务器集群进行测试',
              '准确度较高的测试结果',
              '将流量压测活动周期由数月，降低到一周以内'
            ],
            click: () => {
            }
          },
          {
            title: '跨云数据物流',
            text: [
              '海量致据公网传输',
              '10TB数据10分钟',
              '降低致据迁移成本'
            ],
            click: () => {
            }
          }
        ]
      }
    };
  },
  watch: {
    'tab.active': {
      async handler(newData: any, oldDate: any): Promise<any> {
        await $FN.WaitTime(50);
        this.tab.show = newData;
      }
    }
  },
  beforeCreate(): void {
    SwiperCore.use([ Navigation ]);
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/home/';

.creatAnimation(am_plan, {
  0% {
    .transform(translate(0, 0));
  }
  20% {
    .transform(translate(100px, -100px));
  }
  50% {
    .transform(translate(200px, 0));
  }
  80% {
    .transform(translate(100px, 100px));
  }
  100% {
    .transform(translate(0, 0));
  }
});

.plan {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 0 @padding;
  background-color: @color_7;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.box_swiper {
  position: relative;
  margin: 20px 0 0;
  border-bottom: 1px solid #cacdd4;
  
  .swiper {
    max-width: 140px*5;
    margin: 0 auto;
    
    .swiper-slide {
      @wh: 60px;
      position: relative;
      z-index: 0;
      width: auto;
      
      .loop(@i) when (@i<=6) {
        &:nth-child(@{i}) {
          a::after {
            background-position: -(-1+@i)*@wh 0;
          }
        }
        
        .loop(@i+1);
      }
      .loop(1);
      
      a {
        display: inline-block;
        position: relative;
        z-index: 0;
        width: 110px;
        padding: 65px 0 20px;
        margin: 0 15px;
        .font(center, @text, @color_13, @text);
        .transition(color @time);
        
        &:hover,
        &.active {
          color: @color_6;
          
          &::before {
            opacity: 1;
          }
        }
        
        &::before,
        &::after {
          content: '';
          display: block;
        }
        
        &::before {
          .position(bottom);
          width: 100%;
          height: 4px;
          border-radius: 4px 4px 0 0;
          background: @color_6;
          opacity: 0;
          .transition(opacity @time);
        }
        
        &::after {
          .position(top);
          width: @wh;
          height: @wh;
          margin: 0 auto;
          .bg('@{image}plan_icon.png', @wh*6, @wh);
          .transition(transform @time);
        }
      }
    }
  }
  
  .button_prev,
  .button_next {
    display: block;
    .position(absolute, 0, auto, 0, auto);
    z-index: 1;
    width: 30px;
    min-width: auto;
    height: 100%;
    padding: 0;
    margin: auto 0;
    .borderBox();
    
    &.button_disabled {
      display: none;
    }
    
    > * {
      .font(center, 1, @color_13, @font_7);
    }
  }
  
  .button_prev {
    left: -30px;
  }
  
  .button_next {
    right: -30px;
  }
}

.ant-tabs {
  overflow: initial;
  
  &::before {
    content: '';
    display: block;
    .position(absolute, 250px, auto, auto, -50px);
    z-index: 0;
    .bg('@{image}plan_decorate.png', 185px, 185px, true);
    .animation(am_plan 60s linear infinite forwards);
  }
  
  &:deep(.ant-tabs-nav) {
    display: none;
  }
}

.item {
  position: relative;
  padding: 80px 150px;
  
  .loop(@i) when (@i<=6) {
    &.i_@{i} {
      .image {
        &::before {
          .bg('@{image}plan_image_@{i}_bg.png', 560px, 450px, true);
        }
        
        &::after {
          .bg('@{image}plan_image_@{i}.png', 400px, 450px, true);
        }
      }
    }
    
    .loop(@i+1);
  }
  .loop(1);
  
  &.i_1 {
    .image {
      &::after {
        top: calc(~'50% - 10px');
      }
    }
  }
  
  &.i_2 {
    .image {
      &::after {
        top: calc(~'50% - 40px');
        left: calc(~'50% + 5px');
      }
    }
  }
  
  &.i_3 {
    .image {
      &::after {
        top: calc(~'50% - 20px');
      }
    }
  }
  
  &.i_4,
  &.i_5 {
    .image {
      &::after {
        top: calc(~'50% - 30px');
        left: calc(~'50% - 5px');
      }
    }
  }
  
  &.i_6 {
    .image {
      &::after {
        top: calc(~'50% - 10px');
        left: calc(~'50% + 5px');
      }
    }
  }
  
  &.tab_show {
    .box_content,
    .box_image {
      opacity: 1;
      .transform(translateX(0));
    }
  }
  
  .box_content,
  .box_image {
    @aTime: 1s;
    @style: transform @aTime, opacity @aTime;
    position: relative;
    opacity: 0;
    .transition(@style);
  }
  
  .box_content {
    z-index: 1;
    .transform(translateX(-100px));
  }
  
  .box_image {
    z-index: 0;
    .transform(translateX(100px));
  }
  
  article.ant-typography {
    text-align: left;
    
    h5.ant-typography {
      margin: 0;
      .font(justify, @title_sub, @color_6, @title_sub, true);
    }
    
    div.ant-typography {
      height: 130px;
      margin: @margin 0 0;
      .font(justify, @text+@line+5px, @color_13, @text);
      
      li {
        position: relative;
        
        &::before {
          content: '';
          display: block;
          .position(absolute, 14px, auto, auto, -10px);
          width: 4px;
          height: 4px;
          background: @color_6;
          border-radius: 50%;
        }
      }
    }
  }
  
  .image {
    position: relative;
    min-height: 100%;
    .transform(scale(0.8));
    pointer-events: none;
    
    &::before,
    &::after {
      content: '';
      display: block;
      .position(absolute, 50%, auto, auto, 50%);
      .transition(transform 0.5s ease-out);
    }
    
    &::before {
      top: calc(~'50% + 10px');
      .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.02'), calc(~'-50% + var(--mouse-y,0px) * -0.02')));
    }
    
    &::after {
      .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.01'), calc(~'-50% + var(--mouse-y,0px) * -0.01')));
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .plan {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+10px, @color_12, @title_mo, true);
  }
  
  .box_swiper {
    margin: @margin_mo 10px 0;
    
    .swiper {
      .swiper-slide {
        a {
          margin: 0 5px;
          .font(center, @text_mo, @color_13, @text_mo);
        }
      }
    }
  }
  
  .ant-tabs {
    &::before {
      content: '';
      top: 180px;
      .transform(scale(0.5));
    }
  }
  
  .item {
    padding: 30px 0 0;
    
    .box_content,
    .box_image {
      .transform(translate(0, 50px));
    }
    
    article.ant-typography {
      h5.ant-typography {
        .font(justify, @title_sub_mo, @color_6, @title_sub_mo, true);
      }
      
      div.ant-typography {
        height: 140px;
        margin: @margin_mo 0 0;
        .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
      }
    }
    
    .image {
      min-height: 250px;
      .transform(scale(0.6));
    }
  }
}
</style>